var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1667 2.83333L11.5438 12.1767C11.4893 12.995 11.462 13.4042 11.2853 13.7144C11.1296 13.9876 10.8949 14.2072 10.612 14.3443C10.2907 14.5 9.8806 14.5 9.06043 14.5H5.93965C5.11949 14.5 4.7094 14.5 4.38808 14.3443C4.10519 14.2072 3.87047 13.9876 3.71486 13.7144C3.53811 13.4042 3.51083 12.995 3.45628 12.1767L2.83339 2.83333M1.27783 2.83333H13.7223M10.6112 2.83333L10.4007 2.20183C10.1967 1.58986 10.0946 1.28388 9.90549 1.05765C9.73842 0.857879 9.52391 0.703249 9.28155 0.60794C9.00708 0.5 8.68461 0.5 8.03952 0.5H6.96059C6.3155 0.5 5.99303 0.5 5.71856 0.60794C5.47621 0.703249 5.26167 0.857879 5.09461 1.05765C4.90543 1.28388 4.80344 1.58986 4.59944 2.20183L4.38894 2.83333M9.05561 5.94444V11.3889M5.9445 5.94444V11.3889",
    stroke: "#F63131",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.47b7baf077fe0d51d84c80326ab54cfd.svg";
export { ForwardRef as ReactComponent };